import React, { useState, useEffect, useMemo } from "react";
import { getOr } from "lodash/fp";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { buildUrlFromTableParams } from "../../../../lib/functions/common";
import { mainStateKey, defaultListingTableRowNumber } from "../../../../constants/constants";
import trackDataManipulation from "../../../../lib/dataManipulation/track/trackDataManipulation";
import FiltersBox from "./filtersBox";
import {
  setTableData,
  resetPageOnFilterChange,
  getColumnDefinitions,
  setEditButtonCustomRender,
} from "../../../../lib/functions/tableFunctions";
import { editTrackTableParametersData } from "../../../../constants/tableParametersData/editTrackTableParametersData";
import { usePrevious, useResetPageState } from "../../../../lib/functions/customHooks";
import { SET_STATE_VALUE } from "../../../../redux/reducers/common/actionTypes";
import { dispatchToReduxStore } from "../../../../lib/functions/componentFunctions";
import { useHistory } from "react-router";
import ListingTable from "../../../presentational/table/listingTable";

const EditTrackListPage = ({ filters, sortData, row, page, dispatch }) => {
  useResetPageState();

  const routerHistory = useHistory();
  const statePath = editTrackTableParametersData.statePath;
  const sortPath = editTrackTableParametersData.sortPath;
  const filtersPath = editTrackTableParametersData.filtersPath;
  const allColumns = editTrackTableParametersData.columns;
  const previousFilters = usePrevious(filters);
  const [tableRowData, setTableRowData] = useState([]);
  const [tablePaginationData, setTablePaginationData] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setTableData(
      setTableRowData,
      setTablePaginationData,
      setLoading,
      buildUrlFromTableParams(filters, sortData, editTrackTableParametersData, row, page),
      trackDataManipulation,
      "track"
    );
  }, [filters, sortData, row, page, dispatch]);

  resetPageOnFilterChange(previousFilters, filters, statePath, dispatch);
  let columns = useMemo(
    () => setColumnDefinitions(allColumns, sortPath, dispatch, statePath, routerHistory, tableRowData),
    [allColumns, dispatch, routerHistory, sortPath, statePath, tableRowData]
  );

  return (
    <React.Fragment>
      <section className="content-header">
        <h1>
          Edit track &nbsp;
          <button
            className="btn btn-default btn-small"
            onClick={() => {
              dispatchToReduxStore(filtersPath, SET_STATE_VALUE, null, dispatch);
            }}
          >
            Clear filters
          </button>
        </h1>
      </section>
      <section className="content">
        <FiltersBox />
        <div className={loading ? "loading" : ""}>
          <div className="row">
            <div className="col-md-12">
              <ListingTable
                statePath={statePath}
                sortPath={sortPath}
                tablePaginationData={tablePaginationData}
                columnDefinitions={columns}
                tableRowData={tableRowData}
                columnsConstant={allColumns}
              />
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

const setColumnDefinitions = (allColumns, sortPath, dispatch, statePath, routerHistory) => {
  const columns = getColumnDefinitions(allColumns, sortPath);
  setEditButtonCustomRender(
    columns,
    dispatch,
    statePath,
    routerHistory,
    "/edit/track/",
    "edit",
    "btn btn-default fa fa-edit",
    true
  );
  return columns;
};

EditTrackListPage.propTypes = {
  filters: PropTypes.object,
  row: PropTypes.number,
  page: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  sortData: PropTypes.object,
  dispatch: PropTypes.func,
};

const mapStateToProps = state => {
  return {
    filters: getOr(null, `${mainStateKey}.${editTrackTableParametersData.filtersPath}`, state),
    sortData: getOr(null, `${mainStateKey}.${editTrackTableParametersData.sortPath}`, state),
    row: getOr(defaultListingTableRowNumber, `${mainStateKey}.${editTrackTableParametersData.statePath}.rows`, state),
    page: getOr(0, `${mainStateKey}.${editTrackTableParametersData.statePath}.page`, state),
  };
};

export default connect(mapStateToProps)(EditTrackListPage);
